import type { BaseTranslation } from '../i18n-types';

export const titles = {
    privacy: `Privacy Policy | {appName:string}`,
    terms: `Terms and conditions of use (agreement) | {appName:string}`,
    statement2257: `18 U.S.C. 2257 statement | {appName:string}`,
    room: `Room | {appName:string}`,
    signup: {
        step1: `Verify your email | {appName:string}`,
        step3: `Verify yourself to start | {appName:string}`,
        step4: `Verification in progress | {appName:string}`,
    },
    profile: {
        index: `Edit profile | {appName:string}`,
        changePassword: `Change Password | {appName:string}`,
        subscription: `Subscription | {appName:string}`,
        deactivate: `Deactivate Account | {appName:string}`,
        paymentDetails: `Payment Details | {appName:string}`,
    },
    referral: 'Referral program',
    agencyAgreement: `Agency agreement | {appName:string}`,
    loginOAuth: {
        verify: 'Verify your account',
        failure: 'Login failure',
    },
    signupOAuth: {
        success: 'Signup success',
        failure: 'Signup failure',
    },
} satisfies BaseTranslation;
